<template>
  <div class="menu-content d-flex bg-white rounded-md mb-2">
    <router-link :to="{name: 'menu-detail-page', params: {_id: menu.id}}" class="item-media ">
      <img v-if="menu.image_url" height="400" style="border-radius: 10px;" :src="menu.image_url" alt="food">
      <img v-else-if="isBarMenu" height="400" style="border-radius: 10px;" src="../assets/menu_bar.png">
      <img v-else="isBarMenu" height="400" style="border-radius: 10px;" src="../assets/menu_kitchen.png">
    </router-link>
    <div class="align-items-center justify-content-end d-flex menu-description">
      <div>
        <router-link :to="{name: 'menu-detail-page', params: {_id: menu.id}}" class="mb-1 text-start menu-title" style="font-weight: bold; color: black;">{{menu.name}} </router-link>
        <small class="text-start mb-0 overflow-ellipsis menu-text">{{ menu.description }}</small>
        <p style="font-weight: bold; " class="text-start m-0 text-primary mt-2">{{ menu.price }} f</p>
      </div>
      <div class="justify-content-center align-items-center">
        <button data-bs-toggle="offcanvas" :data-bs-target="'#offcanvasBottom1' + menu.id" aria-controls="offcanvasBottom1" class="btn plus-btn">Plus</button>
      </div>
    </div>
    <div class="offcanvas offcanvas-bottom" tabindex="-1" :id="'offcanvasBottom1' + menu.id">
      <div class="container">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" :id="'offcanvasBottomLabel' + menu.id">Détails</h5>
          <button class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"><i class="fa fa-close"></i></button>
        </div>
        <div class="offcanvas-body small">
          <div class="">
            <div class="image-menu">
              <img v-if="menu.image_url" style="border-radius: 10px;" :src="menu.image_url" alt="food">
              <img v-else-if="isBarMenu" style="border-radius: 10px;" src="../assets/menu_bar.png">
              <img v-else style="border-radius: 10px;" src="../assets/menu_kitchen.png">
            </div>
          </div>
          <p class="mb-1 text-center mt-3 mb-2" style="font-weight: bold; color: black;">{{menu.name}} </p>
          <small class="text-justify mb-0 overflow-ellipsis">{{menu.description}}</small>
          <h5 style="font-weight: bold; " class="text-end m-0 text-primary mt-2">{{ menu.price }} f</h5>
          <br>
          <div>
            <button @click.prevent="goToMenuDetailPaage(menu.id)" class="btn text-primary border-primary bg-transparent w-100"> Ajouter au panier </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import {computed, onMounted} from "vue";
import {useRouter} from "vue-router";

const router = useRouter()
const props = defineProps({
  menu: {
    type: Object,
    default: () => {return {id:1}}
  }
})

const isBarMenu = computed(() => {
  return props.menu.cooking_place == 'BAR'
})

function goToMenuDetailPaage(menuId) {
  $("#offcanvasBottom1"+menuId).offcanvas('hide');
  router.push({name: 'menu-detail-page', params: {_id: props.menu.id}})
}

onMounted(() => {
})
</script>

<style scoped>
.item-media img{
  height: 105px;
  min-width: 105px;
  object-fit: cover;
}

.menu-content{
  padding: 10px;
  height: 125px;

}
.menu-description{
  margin-right: 0px;
  margin-left: 10px;
  justify-content: space-evenly;
}

.menu-text{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.menu-title{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.image-menu img{
  width: 100%;
  height: 150px;
  object-fit: cover;
}

btn{
  border-radius: 10px;
}

.plus-btn{
  font-weight: lighter;
  padding: 3px 8px;
  border-radius: 4px;
  margin-left: 8px;
  border: 1px solid var(--secondary);
  color: var(--secondary);
}
</style>